import { createGlobalStyle } from 'styled-components'
import UbuntuLight from '../assets/fonts/Ubuntu-Light.ttf'
import Ubuntu from '../assets/fonts/Ubuntu-Regular.ttf'
import UbuntuMedium from '../assets/fonts/Ubuntu-Medium.ttf'
import UbuntuBold from '../assets/fonts/Ubuntu-Bold.ttf'
import AirwaveRegular from '../assets/fonts/Airwave-Regular.ttf'
import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  black4: '#efefef',
  black4onBlack4: '#f5f5f5',
  black5: '#979797',
  black16: 'rgba(0, 0, 0, 0.16)',
  black38: 'rgba(0, 0, 0, 0.38)',
  black60: 'rgba(0, 0, 0, 0.6)',
  black87: 'rgba(0, 0, 0, 0.87)',
  white60: 'rgba(255, 255, 255, 0.6)',
  primary50: '#e0eff8',
  primary500: '#0079c4',
  error: '#b00020',
  background: '#f9f9f9',
  backgroundDark: '#282c34',
  surface: 'white',

  ticket_IN_light: '#a84710',
  ticket_IN_dark: '#7e2300',
  ticket_SIN_light: '#ef8249',
  ticket_SIN_dark: '#cb642d',
  ticket_DM_dark: '#c52e18',
  ticket_DM_light: '#e94f32',
  ticket_MA_dark: '#007342',
  ticket_MA_light: '#31915e',
  ticket_MI_dark: '#734ea1',
  ticket_MI_light: '#8e67bd',
  ticket_OP_dark: '#a4316f',
  ticket_OP_light: '#c7528e',
  ticket_ZU_dark: '#008882',
  ticket_ZU_light: '#00aaa3',

  avatar_Firma: '#ff9057',
  avatar_Biuro: '#3acce1',
  avatar_Premium: '#665eff',

  palette: {
    primary: {
      light: '#4da1d6',
      main: '#0079c4',
      dark: '#0066b6',
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: ['Ubuntu-Light'],
  },
  overrides: {
    MuiButton: {
      root: {
        height: '36px',
      },
      label: {
        'font-size': '11px',
      },
    },
    MuiTooltip: {
      tooltip: {
        'font-size': '14px',
      },
    },
    MuiInputLabel: {
      outlined: {
        'background-color': 'white',
        padding: '0 4px',
      },
    },
  },
})

const GlobalStyle = createGlobalStyle`

html {
  @font-face {
  font-family: 'Airwave-Regular';
  font-style: normal;
  font-weight: normal;
  src: url(${AirwaveRegular});
  }
  @font-face {
  font-family: 'Ubuntu-Light';
  font-style: normal;
  font-weight: 300;
  src: url(${UbuntuLight});
  }
  @font-face {
  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 400;
  src: url(${Ubuntu});
  }
  @font-face {
  font-family: 'Ubuntu-Medium';
  font-style: normal;
  font-weight: 500;
  src:  url(${UbuntuMedium});
  }
  @font-face {
  font-family: 'Ubuntu-Bold';
  font-style: normal;
  font-weight: 700;
  src:  url(${UbuntuBold});
  }
  box-sizing: border-box;
}
*, *::before, *::after {
  box-sizing: inherit;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Ubuntu-Light';
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

input {
  text-overflow: ellipsis;
}

.main-layout {
  margin: 24px 0;
}

.caption {
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.4px;
  color: ${props => props.theme.black38};
}

.high-caption {
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.4px;
  color: ${props => props.theme.black87};
}

.medium-emphasis-caption {
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 0.4px;
  color: ${props => props.theme.black60};
}

.disabled-caption {
  font-family: Ubuntu;
  font-size: 11px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.45;
  letter-spacing: 0.4px;
  color: ${props => props.theme.black38};
}

.medium-emphasis-body-2 {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.3px;
  color: ${props => props.theme.black60};
}

.medium-emphasis-body-1 {
  font-size: 16px;
  line-height: 1.75;
  letter-spacing: 0.3px;
  color: ${props => props.theme.black60};
}

.medium-emphasis-body-1 {
  font-size: 16px;
  line-height: 1.75;
  letter-spacing: 0.3px;
  color: ${props => props.theme.black60};
}

.medium-emphasis-subtitle-1 {
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: 0.2px;
  color: ${props => props.theme.black60};
}

.medium-emphasis-subtitle-2 {
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  color: ${props => props.theme.black60};
}

.disabled-subtitle-1 {
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: 0.2px;
  color: ${props => props.theme.black38};
}

.disabled-body-2 {
  font-family: Ubuntu;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: 0.3px;
  color: ${props => props.theme.black38};
}

.disabled-subtitle-2 {
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.1px;
  color: ${props => props.theme.black38};
}

.medium-emphasis-overline {
  font-family: 'Ubuntu-Bold';
  font-size: 11px;
  line-height: 1.43;
  letter-spacing: 1.5px;
  color: ${props => props.theme.black60};
}

.high-emphasis-body-1 {
  font-family: 'Ubuntu';
  font-size: 16px;
  line-height: 1.75;
  letter-spacing: 0.3px;
  color: ${props => props.theme.black87};
}

.high-emphasis-subtitle-1 {
  font-size: 20px;
  line-height: 1.2;
  letter-spacing: 0.2px;
  color: ${props => props.theme.black87};
}

.high-emphasis-body-2 {
  font-family: 'Ubuntu';
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.3px;
  color: ${props => props.theme.black87};
}

.medium-headline-4 {
  font-size: 36px;
  line-height: 1.11;
  letter-spacing: 0.3px;
  color: ${props => props.theme.black60};
}

.medium-headline-5 {
  font-size: 24px;
  line-height: 1.17;
  color: ${props => props.theme.black60};
}

.disabled-headline-5 {
  font-size: 24px;
  line-height: 1.17;
  color: ${props => props.theme.black38};
}

.high-headline-5 {
  font-size: 24px;
  line-height: 1.17;
  color: ${props => props.theme.black87};
}

.white-overline {
  font-family: 'Ubuntu-Bold';
  font-size: 11px;
  line-height: 1.45;
  letter-spacing: 1.5px;
  color: #fff;
}

.primary-overline {
  font-family: 'Ubuntu-Bold';
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 1.5px;
  color: ${props => props.theme.primary500};
}

.white-body-2 {
  font-weight: normal;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.3px;
  color: #fff;
}

.white-body-bold-2 {
  font-weight: bold;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.3px;
  color: #fff;
}

.white-button {
  font-family: 'Ubuntu-Medium';
  font-size: 11px;
  line-height: 1.82;
  letter-spacing: 0.6px;
  color: #fff;
}

@media print {
  @-moz-document url-prefix() {
    .index,
    .main-layout,
    .main{
        display: block !important;
    }
  }
  .info-on-print {
  display: none;
  }
}

.section_header {
  margin-top: 16px;
  margin-left: 12px;
}
`

export { theme, GlobalStyle as default }
